<template>
  <b-form-group
    label="Ad Soyad"
    label-for="name"
  >
    <validation-provider
      #default="{ errors }"
      name="Ad Soyad"
      rules="required"
    >
      <b-form-input
        id="name"
        v-model="itemData.name"
        placeholder="Ad Soyad"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import { BFormGroup, BFormInput } from 'bootstrap-vue'

export default {
  name: 'Name',
  components: {
    BFormGroup,
    BFormInput,
    ValidationProvider,
  },
  computed: {
    itemData() {
      return this.$store.getters['teams/dataItem']
    },
  },
}
</script>
